export default __webpack_public_path__ + "static/media/tiktokOutline.ab082f2f.svg";